import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        public router: Router,
        private messageService: MessageService,
        private cryptoJsService: CryptoJsService,
    ) {
    }

    autoLoggedOut(){
        // this.activityRecordService.activityRecord(this.loginId, 'auto logout', '', new Date(), 'Success');
        this.cryptoJsService.logOut();
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            // if ([403]) {
            //     // auto logout if 403 response returned from api
            //     this.autoLoggedOut();
            //     return;
            // }
            if ([401].includes(err.status) || [403].includes(err.status)) {
                // auto logout if 401 or 403 response returned from api

                this.autoLoggedOut();
                return throwError(err?.statusText);
                // if(err?.statusText == "Unauthorized"){
                //     // auto logged out the user
                //     this.autoLoggedOut();
                // }else{
                //     return throwError(err?.statusText);
                // }
            }
            
            // if ([200, 201].includes(err.status)) {
            //     // auto logout if 401 or 403 response returned from api
            //     console.error(err);
            // }

            else if([500].includes(err.status)) {
                // console.error(err);
                return throwError(err?.error?.error?.message);
            }
            else if([404].includes(err.status)) {
                return throwError(err?.error ? err?.error : err?.statusText);
            }
            else if([0].includes(err.status)) {
                return throwError('Server Error');
            }
            else{
                const error = err.error?.message || err.error?.login_failure || err.error?.text || err.statusText ;
                // console.error(err);
                return throwError(error); 
            }
        }))
    }
}
